<template>
  <div slot="header" class="acts-editor-header">
    <icon size="16" type="md-document" class="ms-help" />
    <span style="margin-left: 4px" class="ms-help">
      {{ act.id ? `Акт № ${act.number}` : "Создание акта" }}
    </span>
  </div>
</template>

<script>
export default {
  props: ['act']
}
</script>

<style lang="less">
.acts-editor-header {
  display: flex;
  align-items: center;
}
</style>
